import { FunctionComponent } from 'react'
import styles from './rateInfo.module.scss'
import { useTranslation } from 'react-i18next'
import { ErrorOutline, InfoOutlined, WarningAmber } from '@mui/icons-material'
import { RateType } from '@/types/StaffRate.ts'

interface RateInfoProps {
    hours: string
    hasRequiredStaff: boolean
    staff: number
    child: number
    available: number
    realRate: RateType
    potentialRate: RateType
}

const RateInfo: FunctionComponent<RateInfoProps> = ({
    hours,
    hasRequiredStaff,
    staff,
    child,
    available,
    realRate,
    potentialRate
}: RateInfoProps) => {
    const { t } = useTranslation()

    function round(value: number): number {
        const tmp: number = Math.pow(10, 1)
        return Math.round(value * tmp) / tmp
    }

    const real: number = round(staff > 0 ? child / staff : child)
    const potential: number = round(staff > 0 ? (child + available) / staff : child)

    return (
        <div className={styles.Tooltip}>
            <div className={styles.Hours}>{hours}</div>
            <div className={styles.IndicatorsContainer}>
                <div className={styles.Indicator}>
                    <div className={styles.Count}>{child}</div>
                    <div className={styles.Text}>{child > 1 ? t('childs') : t('child')}</div>
                </div>
                <div className={styles.Indicator}>
                    <div className={styles.Count}>{staff}</div>
                    <div className={styles.Text}>{staff > 1 ? t('staffs') : t('staff')}</div>
                </div>
            </div>
            {staff > 0 ? (
                <div className={styles.TextContainer}>
                    <div className={`${styles.Line} ${realRate === RateType.success ? styles.Success : styles.Error}`}>
                        <InfoOutlined className={styles.Icon} />
                        {t('real')}: {real} {real > 1 ? t('childsPerStaff') : t('childPerStaff')}
                    </div>
                    <div
                        className={`${styles.Line} ${potentialRate === RateType.success ? styles.Success : styles.Warning}`}
                    >
                        {potentialRate === RateType.success ? (
                            <InfoOutlined className={styles.Icon} />
                        ) : (
                            <WarningAmber className={styles.Icon} />
                        )}
                        {t('potential')}: {potential} {potential > 1 ? t('childsPerStaff') : t('childPerStaff')}
                    </div>
                    {!hasRequiredStaff && (
                        <div className={`${styles.Line} ${styles.Error}`}>
                            <ErrorOutline className={styles.Icon} />
                            {t('noRequiredDiplomatStaff')}
                        </div>
                    )}
                    {staff < 2 && (
                        <div className={`${styles.Line} ${styles.Warning}`}>
                            <WarningAmber className={styles.Icon} />
                            {t('2StaffsRequired')}
                        </div>
                    )}
                </div>
            ) : (
                <div className={styles.TextContainer}>
                    <div className={`${styles.Line} ${styles.Error}`}>
                        <ErrorOutline className={styles.Icon} />
                        {t('noStaffs')}
                    </div>
                </div>
            )}
        </div>
    )
}

export default RateInfo
